<template>
  <el-form label-width="60" inline class="elementui-common-form-styles" v-highlight>
    <el-form-item>
      <ElInput
        v-model.trim="queryForm.keyWord"
        placeholder="请输入视频ID/名称名称"
        clearable
        style="width: 220px"
        @clear="queryAction"
        @keyup.enter.native="queryAction"
      >
        <i slot="append" @click="queryAction" class="el-icon-search"></i>
      </ElInput>
    </el-form-item>

    <el-form-item>
      <el-select v-model="queryForm.type" @change="queryAction" clearable style="width: 180px" placeholder="素材类型">
        <el-option v-for="item in MATERIAL_TYPE_LIST" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-select v-model="queryForm.taskType" @change="queryAction" clearable style="width: 180px" placeholder="视频来源">
        <el-option v-for="item in TASK_TYPE_LIST" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-select v-model="queryForm.uploadOpId" @change="queryAction" filterable clearable style="width: 160px" placeholder="上传人员">
        <el-option v-for="item in operatorData" :key="item.id" :value="item.id" :label="item.name"> </el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-select v-model="queryForm.mgameId" @change="queryAction" filterable clearable style="width: 180px" placeholder="中间件游戏">
        <el-option v-for="item in midGames" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-select v-model="queryForm.analysisStatus" @change="queryAction" clearable style="width: 180px" placeholder="素材解析状态">
        <el-option v-for="item in AI_ANALYSIS_LIST" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-select v-model="queryForm.estimateStatus" @change="queryAction" clearable style="width: 180px" placeholder="素材评估状态">
        <el-option v-for="item in AI_ESTIMATE_LIST" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-select v-model="queryForm.auditStatus" @change="queryAction" clearable style="width: 180px" placeholder="素材审核状态">
        <el-option v-for="item in AI_AUDIT_LIST" :key="item.id" :value="item.id" :label="item.name"></el-option>
      </el-select>
    </el-form-item>

    <el-form-item>
      <DateRangePicker @change="queryAction" v-model="queryForm.dateRange" style="width: 220px"></DateRangePicker>
    </el-form-item>

    <el-form-item class="bg-transparent">
      <slot></slot>
    </el-form-item>
  </el-form>
</template>

<script setup>
import { ref, computed } from 'vue'
import DateRangePicker from '@/components/date-range-picker'
import { initPageData, MID_GAMES, SYS_USERS } from '@/data/global-opts'
import { IMAGE_TYPES, AI_AUDIT_LIST, AI_ANALYSIS_LIST, AI_ESTIMATE_LIST, TASK_TYPE_LIST, MATERIAL_TYPE_LIST } from '../../consts.js'
const PAGE_REQUIRED_OPTS = initPageData([MID_GAMES, SYS_USERS])
const midGames = computed(PAGE_REQUIRED_OPTS.MID_GAMES)
const operatorData = computed(PAGE_REQUIRED_OPTS.SYS_USERS)
// eslint-disable-next-line
const emits = defineEmits(['query'])

const queryForm = ref({
  keyWord: '',
  uploadOpId: null,
  mgameId: '',
  taskType: '',
  type: '',
  auditStatus: '',
  estimateStatus: '',
  analysisStatus: '',
  dateRange: []
})

const queryAction = () => {
  emits('query')
}

// eslint-disable-next-line
defineExpose({
  buildParams() {
    const { dateRange, uploadOpId, ...rest } = queryForm.value
    const [beginTime = '', endTime = ''] = dateRange || []
    return {
      beginTime,
      endTime,
      ...rest,
      uploadOpId: uploadOpId || -1
    }
  }
})
</script>

<style lang="scss" scoped></style>
